import { render } from "./WipPowderView.vue?vue&type=template&id=08f48f06&scoped=true"
import script from "./WipPowderView.vue?vue&type=script&lang=js"
export * from "./WipPowderView.vue?vue&type=script&lang=js"

import "./WipPowderView.vue?vue&type=style&index=0&id=08f48f06&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f48f06"]])

export default __exports__